import type { ProjectItem } from '@store/reducers/dashboard/types'
import type React from 'react'

import { ProjectListItem, ProjectsNotFound } from './components'
import css from './styles.module.css'

interface Props {
  projects: ProjectItem[]
}

// Projects as tiles with a preview. The compact alternative is ProjectsRows;
// the dashboard picks between the two.
export const ProjectsList: React.FC<Props> = ({ projects }) => {
  if (!projects.length) {
    return <ProjectsNotFound />
  }

  return (
    <div className={css.projects_list}>
      {projects.map((project) => (
        <ProjectListItem project={project} key={project.id} />
      ))}
    </div>
  )
}
